var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "suppleMaterial global-page-base-layout" },
    [
      _c("div", { staticClass: "select-conditions" }, [
        _c(
          "div",
          { staticClass: "select-conditions-row" },
          [
            _c("el-col", { attrs: { span: 8 } }, [
              _c(
                "div",
                { staticClass: "grid-content bg-purple-light" },
                [
                  _vm._v("\n                   状态：\n                   "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "60%" },
                      attrs: { size: "medium", placeholder: "请选择状态" },
                      model: {
                        value: _vm.state,
                        callback: function ($$v) {
                          _vm.state = $$v
                        },
                        expression: "state",
                      },
                    },
                    _vm._l(_vm.stateArr, function (item) {
                      return _c("el-option", {
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "select-conditions-row",
            staticStyle: { "text-indent": "5em", "margin-top": "20px" },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "medium" },
                on: { click: _vm.screen },
              },
              [_vm._v("筛选")]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "clear-all", on: { click: _vm.clearAllConditon } },
              [_vm._v("清空筛选条件")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "suppleMaterial-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { width: "150", label: "案号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.caseNo
                          ? _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.caseNo))]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v("暂无案号")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitrationReason", label: "案由" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appName", label: "变更申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "applyTime", label: "申请时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "state", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.reviewState[scope.row.state]) +
                            "\n            "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.state == "0"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReview(scope.row)
                                  },
                                },
                              },
                              [_vm._v("审核\n              ")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReview(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看\n              ")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "材料文件", visible: _vm.fileVisble },
          on: {
            "update:visible": function ($event) {
              _vm.fileVisble = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fileLoading,
                  expression: "fileLoading",
                },
              ],
              staticStyle: { width: "100%", "margin-left": "10px" },
              attrs: { data: _vm.MaterialData },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "fileName", label: "名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: {
                              type: "primary",
                              underline: false,
                              href: scope.row.aliyunOssHref,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.fileName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核",
            visible: _vm.reviewVisible,
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.reviewVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "reviewForm",
              attrs: { "label-position": "right", "label-width": "120px" },
            },
            [
              _c("h4", [_vm._v("原仲裁请求")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "仲裁金额：" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "", disabled: "" },
                      model: {
                        value: _vm.reviewForm.oldControversyAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.reviewForm, "oldControversyAmount", $$v)
                        },
                        expression: "reviewForm.oldControversyAmount",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("元")])],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "仲裁请求：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    attrs: { placeholder: "", disabled: "" },
                    model: {
                      value: _vm.reviewForm.oldArbitrationRequest,
                      callback: function ($$v) {
                        _vm.$set(_vm.reviewForm, "oldArbitrationRequest", $$v)
                      },
                      expression: "reviewForm.oldArbitrationRequest",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "事实与理由：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    attrs: {
                      placeholder: "",
                      disabled: "",
                      type: "textarea",
                      rows: 4,
                    },
                    model: {
                      value: _vm.reviewForm.oldArbitrationAruth,
                      callback: function ($$v) {
                        _vm.$set(_vm.reviewForm, "oldArbitrationAruth", $$v)
                      },
                      expression: "reviewForm.oldArbitrationAruth",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("h4", [_vm._v("变更后仲裁请求")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "仲裁金额：" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "", disabled: "" },
                      model: {
                        value: _vm.reviewForm.controversyAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.reviewForm, "controversyAmount", $$v)
                        },
                        expression: "reviewForm.controversyAmount",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("元")])],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "仲裁请求：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    attrs: { placeholder: "", disabled: "" },
                    model: {
                      value: _vm.reviewForm.arbitrationRequest,
                      callback: function ($$v) {
                        _vm.$set(_vm.reviewForm, "arbitrationRequest", $$v)
                      },
                      expression: "reviewForm.arbitrationRequest",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "事实与理由：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    attrs: {
                      placeholder: "",
                      disabled: "",
                      type: "textarea",
                      rows: 4,
                    },
                    model: {
                      value: _vm.reviewForm.arbitrationAruth,
                      callback: function ($$v) {
                        _vm.$set(_vm.reviewForm, "arbitrationAruth", $$v)
                      },
                      expression: "reviewForm.arbitrationAruth",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "变更仲裁申请书:" } },
                [
                  _c(
                    "el-link",
                    {
                      attrs: {
                        href: _vm.reviewForm.aliyunOssHref,
                        target: "_blank",
                        type: "primary",
                        underline: false,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.reviewForm.fileName) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.clickState == 0
                ? _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.btnLoading },
                      on: {
                        click: function ($event) {
                          return _vm.handleReject("reviewForm")
                        },
                      },
                    },
                    [_vm._v("驳回")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.clickState == 0
                ? _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.btnLoading, type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handlePass("reviewForm")
                        },
                      },
                    },
                    [_vm._v("通过")]
                  )
                : _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.reviewVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "驳回",
            visible: _vm.rejectVisible,
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rejectVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "rejectForm",
              attrs: {
                "label-position": "right",
                "label-width": "120px",
                model: _vm.rejectForm,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "理由：",
                    prop: "reason",
                    rules: { required: true, message: "请填写" },
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      placeholder: "请填写驳回理由",
                    },
                    model: {
                      value: _vm.rejectForm.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.rejectForm, "reason", $$v)
                      },
                      expression: "rejectForm.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rejectVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.btnLoading, type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleRejectSubmit("rejectForm")
                    },
                  },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("send-case", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.sendCaseVisible,
            expression: "sendCaseVisible",
          },
        ],
        ref: "sendCase",
        on: {
          handleShowing: _vm.updateShow,
          handleErrorShowing: _vm.updateErrorShow,
          initList: _vm.refreshPage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }